export const formatPrice = (n) =>
  new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    maximumFractionDigits: Number.isInteger(n) ? 0 : 2,
  }).format(n);
